import { $generateNodesFromDOM } from '@lexical/html';
import { InitialConfigType, LexicalComposer } from '@lexical/react/LexicalComposer';
import { styled, Theme } from '@nexelem/deprecated-theme';
import { $createParagraphNode, $getRoot, $insertNodes, LexicalEditor, TextNode } from 'lexical';
import { SettingsContext } from './context/SettingsContext';
import { SharedHistoryContext } from './context/SharedHistoryContext';
import Editor, { EditorProps } from './Editor';
import { globalNodes } from './nodes';
import { TableContext } from './plugins/TablePlugin/TableContext';
import theme from './themes/theme';
import { getInputStateDefaultStyles } from '../styleUtils';

const StyledContainer = styled('div')(({ theme }) => {
  const typedTheme = theme as Theme;

  return {
    ...getInputStateDefaultStyles(typedTheme),
  };
});

function prepopulatedRichText(initValue?: string) {
  return (editor: LexicalEditor) => {
    const root = $getRoot();
    if (root.getFirstChild() === null && initValue) {
      const parser = new DOMParser();
      const dom = parser.parseFromString(initValue, 'text/html');
      const nodes = $generateNodesFromDOM(editor, dom);
      $getRoot().select();
      try {
        $insertNodes(nodes);
      } catch (e) {
        try {
          $insertNodes(
            nodes.map((node) => {
              if (node instanceof TextNode) {
                return $createParagraphNode().append(node);
              }
              return node;
            }),
          );
          // eslint-disable-next-line no-empty
        } catch {}
      }
    }
  };
}

type RichTextFieldProps = EditorProps & {
  readonly value?: string;
};

export const RichTextField = ({ value, onChange }: RichTextFieldProps) => {
  const initialConfig: InitialConfigType = {
    theme,
    editorState: prepopulatedRichText(value),
    namespace: 'richTextEditor',
    nodes: [...globalNodes],
    onError: (error: Error) => {
      console.error(error);
      throw error;
    },
  };
  return (
    <SettingsContext>
      <StyledContainer className="w-full rounded-xs border border-border-primary leading-[1.7]">
        <LexicalComposer initialConfig={initialConfig}>
          <SharedHistoryContext>
            <TableContext>
              <Editor onChange={onChange} />
            </TableContext>
          </SharedHistoryContext>
        </LexicalComposer>
      </StyledContainer>
    </SettingsContext>
  );
};

RichTextField.displayName = 'RichTextField';
